import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router';

import { config } from './config';
import { main } from './configuration';
import { store } from './configuration/setup/store';
import { handleLoginRedirect } from './configuration/login/redirect';
import { ErrorBoundary } from './components/ErrorBoundary';
import App from './layout/App';

const renderApplication = () => {
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
        <ErrorBoundary>
            <Provider store={store}>
                <HashRouter>
                    <App />
                </HashRouter>
            </Provider>
        </ErrorBoundary>
    );
};

const isDev = import.meta.env.DEV;
const isProd = import.meta.env.PROD;
const isProdPreview = import.meta.env.VITE_PRODUCTION_PREVIEW;
const isCypress = import.meta.env.VITE_CYPRESS_TEST_RUNTIME;
const shouldStartMockServer = (isDev && config.enableMockServer) || isProdPreview;

const canRegisterServiceWorker = () =>
    typeof window !== 'undefined' &&
    window.isSecureContext &&
    typeof navigator !== 'undefined' &&
    'serviceWorker' in navigator;

const startMockServer = async () => {
    if (!shouldStartMockServer) {
        return;
    }

    if (!canRegisterServiceWorker()) {
        console.warn('[MSW] Skipping Service Worker registration because the current browser context is insecure.');
        return;
    }

    try {
        const { startWorker } = await import('../mocks/serviceMock');
        await startWorker();
    } catch (error) {
        console.warn('[MSW] Failed to start request mocking. Continuing without MSW.', error);
    }
};

const bootstrapApplication = async () => {
    await startMockServer();
    await main(renderApplication);
};

if (window.location.href.startsWith(config.login.redirectUri as string)) {
    handleLoginRedirect();
} else if (isDev && isCypress === 'true') {
    void main(renderApplication);
} else if (isDev || isProd || isProdPreview) {
    void bootstrapApplication();
}
